<template>
  <el-dialog title="下游报价" :visible.sync="dialogIsShow" width="550px" :close-on-click-modal="false" ref="dialog"
    append-to-body>
    <div class="dia_body">
      <el-form label-width="140px" label-position="left" style="" v-if="jobDownPrice">
        <el-form-item label="报价批次：" size="small">
          {{ jobDownPrice.BatchNum }}
        </el-form-item>
        <el-form-item label="接单方角色：" size="small">
          {{ jobDownPrice.ReceiverUserType == 1 ? "工程师" : "服务站" }}
        </el-form-item>
        <el-form-item label="接单方姓名：" size="small">
          {{ jobDownPrice.ReceiverUserName }}
        </el-form-item>
        <el-form-item label="人工费单价：" size="small">
          {{ jobDownPrice.ManHourPrice }}
        </el-form-item>
        <el-form-item label="人工费数量：" size="small">
          {{ jobDownPrice.ManHourCount }}
        </el-form-item>
        <el-form-item label="人工费合计：" size="small">
          {{ jobDownPrice.ManHourAmount }}
        </el-form-item>

        <el-form-item label="交通费单价：" size="small">
          {{ jobDownPrice.TrafficPrice }}
        </el-form-item>
        <el-form-item label="交通费数量：" size="small">
          {{ jobDownPrice.TrafficCount }}
        </el-form-item>
        <el-form-item label="交通费合计：" size="small">
          {{ jobDownPrice.TrafficAmount }}
        </el-form-item>

        <el-form-item label="材料费单价：" size="small">
          {{ jobDownPrice.MateriaPrice }}
        </el-form-item>
        <el-form-item label="材料费数量：" size="small">
          {{ jobDownPrice.MateriaCount }}
        </el-form-item>
        <el-form-item label="材料费合计：" size="small">
          {{ jobDownPrice.MateriaAmount }}
        </el-form-item>

        <el-form-item label=" 其他费用单价：" size="small">
          {{ jobDownPrice.OtherPrice }}
        </el-form-item>
        <el-form-item label="其他费用数量：" size="small">
          {{ jobDownPrice.OtherCount }}
        </el-form-item>
        <el-form-item label="其他费用合计：" size="small">
          {{ jobDownPrice.OtherAmount }}
        </el-form-item>

        <el-form-item label="计费类型：" size="small">
          {{ jobDownPrice.BillType == 0 ? "按天" : "整包" }}
        </el-form-item>

        <el-form-item label="总费用：" size="small">
          {{ jobDownPrice.TotalAmount }}
        </el-form-item>

        <el-form-item label="不含税利润率：" size="small" v-if="isProjectJob == 0">
          {{ jobDownPrice.NoTaxProfitRate }}%
        </el-form-item>

        <el-form-item label="报价客服：" size="small" >
          {{ jobDownPrice.AdminUserName }}
        </el-form-item>
        <el-form-item label="报价时间：" size="small" >
          {{ jobDownPrice.CreateTime }}
        </el-form-item>
        <el-form-item label="状态：" size="small" >
          {{ jobDownPrice.AuditStatusName}}
        </el-form-item> 
        
        <el-form-item label="审核人：" size="small" v-if=" jobDownPrice.AuditStatus!=0">
          {{ (jobDownPrice.AuditAdminUserName||'--') }}
        </el-form-item>
         <el-form-item label="审核备注：" size="small" v-if="jobDownPrice.AuditStatus!=0">
          {{ jobDownPrice.Remark }}
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogIsShow = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogIsShow: false,
      jobId: 0,
      isProjectJob: 0,
      jobDownPrice: null
    };
  },
  created() {

  },

  computed: {

  },
  methods: {
    openDia(jobDownPrice, isProjectJob) {
      this.jobDownPrice = jobDownPrice;
      this.dialogIsShow = true;
      this.isProjectJob = isProjectJob;

      // console.log("this.jobDownPrice:" + JSON.stringify(this.jobDownPrice));
    },


  }
};
</script>

<style scoped lang="scss">
.dia_body {
  padding: 0 15px;
  // border: 1px solid red;

  .el-form-item {
    margin-bottom: 5px !important;
  }
}
</style>